/** Resumen en texto de lo capturado para un partido (tarjeta móvil de
 * Resultados, Eduardo 2026-09-11): marcador, ganador y excepción. */
export function resultSummaryText(options: {
  score: string | null | undefined;
  winnerName: string | null | undefined;
  exception: "" | "walkover" | "retired" | "defaulted" | string | null | undefined;
}): string {
  if (options.exception === "double_walkover") return "Doble W.O.: nadie avanza";
  const parts: string[] = [];
  const score = (options.score ?? "").trim();
  if (score) parts.push(score);
  const winner = (options.winnerName ?? "").trim();
  if (winner) parts.push(`Gana ${winner}`);
  if (options.exception === "walkover") parts.push("W/O");
  if (options.exception === "retired") parts.push("Retiro");
  if (options.exception === "defaulted") parts.push("Default");
  return parts.length > 0 ? parts.join(" · ") : "Sin resultado capturado";
}
